import React, { useEffect, useLayoutEffect } from 'react';
import LoadingSpinner from '../../../../atoms/loading-spinner';
import LocationDetails from '../../../../../data-containers/location-details';
import ErrorWithTooltip from '../../../../atoms/error-with-tooltip';
import DynamicCell from '../../../../atoms/table/dynamic-cell';
import FleetLink from '../../../../atoms/fleet-link';

function FleetContent(props){
  const { getDetail, passiveFetchInstallations } = LocationDetails.useContainer();
  const { adjustRowHeight, rowData, omitAddToActive } = props;
  const { id, expanded } = rowData;
  const detail = getDetail(id) || {};
  const { fleet, installations=[], installationsLoading=true, installationsError } = detail;

  useEffect(
    () => {
      if(detail.id && !detail.installations && !detail.installationsLoading){
        passiveFetchInstallations(id, { omitAddToActive });
      }
    },
    [detail.id]
  );

  useLayoutEffect(
    () => {
      adjustRowHeight();
    },
    [fleet, expanded]
  );

  if(installationsLoading){
    return <LoadingSpinner className="inline" />;
  }
  if(installationsError){
    return <ErrorWithTooltip error={installationsError} />;
  }
  if(!installations.length){    
    return null;
  }

  return <FleetLink fleetId={fleet} />;
}

function Wrapper(props){
  return <div className="location-row-fleet">
    <FleetContent {...props} />
  </div>;
}

export default DynamicCell(Wrapper);